import React from 'react';
import { AchPaymentMethodNotAllowedModal } from '@app/_components/error/customErrorModals/AchPaymentMethodNotAllowedModal';
import { ActivationFeeOverpaidModal } from '@app/_components/error/customErrorModals/ActivationFeeOverpaidModal';
import { ActiveDealershipContractErrorModal } from '@app/_components/error/customErrorModals/ActiveDealershipContractErrorModal';
import { ActiveEnduranceContractErrorModal } from '@app/_components/error/customErrorModals/ActiveEnduranceContractErrorModal';
import { ClosedQuoteErrorModal } from '@app/_components/error/customErrorModals/ClosedQuoteError';
import { ConsumerIdNullModal } from '@app/_components/error/customErrorModals/ConsumerIdNullModal';
import { ContractModificationDisabledModal } from '@app/_components/error/customErrorModals/ContractModificationDisabledModal';
import { DownPaymentOverpaidModal } from '@app/_components/error/customErrorModals/DownPaymentOverpaidModal';
import { EcommerceRewriteRequiredModal } from '@app/_components/error/customErrorModals/EcommerceRewriteRequired';
import { InvalidSelectedPlan } from '@app/_components/error/customErrorModals/InvalidSelectedPlan';
import { RewriteNotAllowedModal } from '@app/_components/error/customErrorModals/RewriteNotAllowedModal';
import { VinUpdateChangesVehicleModal } from '@app/_components/error/customErrorModals/VinUpdateChangesVehicleModal';
import { CustomValidationExceptionEnum } from '@lib/enums/CustomValidationExceptionEnum';
import { ParameterTypeEnum } from '@lib/enums/ParameterTypeEnum';
import type { ReactNode } from 'react';
export type TCustomValidationException = {
  errorType: CustomValidationExceptionEnum;
  description: string;
  parameters: Record<number, string>;
};
export interface ICustomValidationExceptionMetadata {
  id: CustomValidationExceptionEnum;
  description: string;
  component: (onClose: () => void, params: Record<ParameterTypeEnum, string>) => ReactNode;
}
export type TCustomValidationExceptionMetadata = { [key in CustomValidationExceptionEnum]: ICustomValidationExceptionMetadata };
export const customValidationException: TCustomValidationExceptionMetadata = {
  [CustomValidationExceptionEnum.QuoteClosed]: {
    id: CustomValidationExceptionEnum.QuoteClosed,
    description: 'This quote is closed',
    component: (onClose: () => void, params: Record<number, string>) => <ClosedQuoteErrorModal onClose={onClose} params={params} />
  },
  [CustomValidationExceptionEnum.ActiveEnduranceContract]: {
    id: CustomValidationExceptionEnum.ActiveEnduranceContract,
    description: 'This VIN is tied to an active dealership contract and cannot be sold.',
    component: (onClose: () => void, params: Record<number, string>) => <ActiveEnduranceContractErrorModal onClose={onClose} params={params} />
  },
  [CustomValidationExceptionEnum.InvalidSelectedPlan]: {
    id: CustomValidationExceptionEnum.InvalidSelectedPlan,
    description: 'Invalid selected plan',
    component: (onClose: () => void, params: Record<number, string>) => <InvalidSelectedPlan onClose={onClose} params={params} />
  },
  [CustomValidationExceptionEnum.ActiveDealershipContract]: {
    id: CustomValidationExceptionEnum.ActiveDealershipContract,
    description: 'This VIN is tied to an active dealership contract and cannot be sold.',
    component: (onClose: () => void, params: Record<number, string>) => <ActiveDealershipContractErrorModal onClose={onClose} vin={params[ParameterTypeEnum.Vin]} dealerContractSource={params[ParameterTypeEnum.DealerContractSource]} />
  },
  [CustomValidationExceptionEnum.RewriteDisabled]: {
    id: CustomValidationExceptionEnum.RewriteDisabled,
    description: 'Cannot rewrite this contract because it was recently sold, please flat cancel.',
    component: (onClose: () => void, params: Record<number, string>) => <ContractModificationDisabledModal onClose={onClose} params={params} />
  },
  [CustomValidationExceptionEnum.ActivationFeeOverpaid]: {
    id: CustomValidationExceptionEnum.ActivationFeeOverpaid,
    description: 'The Elite Club activation fee has already been captured and cannot be removed.',
    component: (onClose: () => void, params: Record<number, string>) => <ActivationFeeOverpaidModal onClose={onClose} params={params} />
  },
  [CustomValidationExceptionEnum.DownPaymentOverpaid]: {
    id: CustomValidationExceptionEnum.DownPaymentOverpaid,
    description: 'The Down payment has already been captured and cannot be altered.',
    component: (onClose: () => void, params: Record<number, string>) => <DownPaymentOverpaidModal onClose={onClose} params={params} />
  },
  [CustomValidationExceptionEnum.AchPaymentMethodNotAllowed]: {
    id: CustomValidationExceptionEnum.AchPaymentMethodNotAllowed,
    description: 'ACH payment is not allowed for this sale, please select a different payment method.',
    component: (onClose: () => void) => <AchPaymentMethodNotAllowedModal onClose={onClose} />
  },
  [CustomValidationExceptionEnum.ConsumerIdNull]: {
    id: CustomValidationExceptionEnum.ConsumerIdNull,
    description: 'Consumer Id is null please wait and try again',
    component: (onClose: () => void) => <ConsumerIdNullModal onClose={onClose} />
  },
  [CustomValidationExceptionEnum.NoChangesMadeRequiringRewrite]: {
    id: CustomValidationExceptionEnum.NoChangesMadeRequiringRewrite,
    description: 'Rewrite not allowed',
    component: (onClose: () => void) => <RewriteNotAllowedModal onClose={onClose} />
  },
  [CustomValidationExceptionEnum.EcommerceRewriteRequired]: {
    id: CustomValidationExceptionEnum.EcommerceRewriteRequired,
    description: 'Rewrite not allowed',
    component: (onClose: () => void) => <EcommerceRewriteRequiredModal onClose={onClose} />
  },
  [CustomValidationExceptionEnum.VinUpdateChangesVehicle]: {
    id: CustomValidationExceptionEnum.VinUpdateChangesVehicle,
    description: 'VIN update not allowed',
    component: (onClose: () => void) => <VinUpdateChangesVehicleModal onClose={onClose} />
  }
};